import { Loader } from './loader';

export class AppLoader extends Loader {
    constructor() {
      super('https://base-proxy.onrender.com/https://newsapi.org/v2/', {
            apiKey: 'c3ff8709bc9e4c73b46b804f2f5242a9',
        });
    }
}
